import React from 'react'
import Rating from "@mui/material/Rating"

type Props = {
    row: any
}

const RatingIcon = (props: Props) => {

    const { row } = props

    return (
        <>
            <span
                style={{
                    width: "34px",
                    height: "34px",
                    backgroundColor: "#F7F7F7",
                    border: "0px solid #F7F7F7",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "4px",
                }}
            >
                <Rating
                    value={
                        row?.original
                            ?.childrenHasOps === true
                            ? 1
                            : 0
                    }
                    max={1}
                    disabled
                />
            </span>
        </>
    )
}

export default RatingIcon